import type { Clock } from 'ProdantixSdk/core/types';

export const systemClock: Clock = {
  now: () => new Date(),
};

export function isoTimestamp(date: Date): string {
  return date.toISOString();
}

/** The visitor's IANA time zone in a browser, or null elsewhere: on a server
 *  the runtime's zone is the server's, not the person's. */
export function browserTimeZone(): string | null {
  if (typeof window === 'undefined' || typeof Intl === 'undefined') return null;
  const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return typeof zone === 'string' && zone !== '' ? zone : null;
}
